module.exports = __webpack_public_path__ + "media/images/icons/settings-dark-3b0a1e94d96a9dbbdc12bd2436e672b0.svg";